.SyncActionBar {
    position: sticky;
    bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    padding: 14px 18px;
    box-shadow: 0 12px 40px
        light-dark(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.5));
    backdrop-filter: blur(16px);
}

.SyncActionBar__note {
    display: flex;
    align-items: center;
    gap: 8px;

    & svg {
        flex-shrink: 0;
    }

    & strong {
        color: var(--soniq-t--global--text--color--primary--default);
        font-weight: var(--soniq-t--global--font--weight--semibold);
    }
}
